/**
 * Bill Payments container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Actions from './actions';
import BillPayments from '../../Components/BillPayments/BillPayments';
import {
  loadingSelector,
  errorSelector,
  billPaymentsSelector,
  countSelector,
} from './selectors';

const { getBillPayments } = Actions;

/**
 * Properties to be provided to the bill payment component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  billPayments: billPaymentsSelector(state),
  count: countSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill payment actions
 */
const mapDispatchToProps = (dispatch) => ({
  getBillPayments: (userId, params) =>
    dispatch(getBillPayments(userId, params)),
});

/**
 * Connects state to the Bill Payment component
 *
 * @param {object} mapStateToProps data object to become props for the Bill Payments component
 * @param {object} mapDispatchToProps Bill Payments actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BillPayments),
);
